var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1986_44834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1986_44834)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      verticalAlign: "middle !important"
    },
    d: "M8.66667 3.33333V9.46667L11.0667 7.06667L12 8L8 12L4 8L4.93333 7.06667L7.33333 9.46667L7.33333 3.33333H8.66667Z",
    fill: "#7D5CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTooltip);
export default __webpack_public_path__ + "static/media/ArrowDownTooltip.ee575ed51dd58b3c535a1ae1b6a3cb51.svg";
export { ForwardRef as ReactComponent };